import React, { useState, useEffect } from "react";
import NavbarPage from "../../components/navbar/page";
import EmployeeNavbarVertical from "../../components/employeeNavbarVertical/page";
import { useLocation, useSearchParams, Outlet } from "react-router-dom";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PlanningBacklogTab from "../../components/planningsprint/PlanningBacklogTab/page";
import EmployeeActiveSprint from "../../components/employeeActiveSprint/page";
import EmployeeCompletedSprint from "../../components/employeeCompletedSprint/page";
import EmployeeDashboard from "../dashboard/EmployeeDashboard/page";
import { getAllTeams } from "../api/team";
import { getAllSprints } from "../api/sprint";

const EmployeeLayout = () => {
  // Single source of truth for the active tab: react-router's own
  // useSearchParams (not window.location), so the router's internal
  // location state never drifts out of sync with the real URL.
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || "dashboard";
  const { pathname } = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => window.innerWidth >= 768);
useEffect(() => {
  const sync = () => {
    const s = localStorage.getItem("selectedSprint");
    if (s) setSelectedSprint(JSON.parse(s));
  };
  window.addEventListener("sprintChanged", sync);
  return () => window.removeEventListener("sprintChanged", sync);
}, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handler = () => setIsSidebarOpen(prev => !prev);
    window.addEventListener("toggleSidebar", handler);
    return () => window.removeEventListener("toggleSidebar", handler);
  }, []);

  const [teams, setTeams] = useState([]);
  const token = localStorage.getItem("token");
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [selectedSprint, setSelectedSprint] = useState(null);
  const [sprints, setSprints] = useState([]);

  const isReportingPage = pathname.startsWith("/employeereporting");
  const isTicketingPage = pathname.startsWith("/employee-ticketing");

  useEffect(() => {
    const fetchTeams = async () => {
      try {
        const response = await getAllTeams(token);
        if (response.status === 200) {
          setTeams(response.data);
        }
      } catch (error) {
        console.error("Error fetching teams:", error);
      }
    };

    const fetchSprints = async () => {
  try {
    const res = await getAllSprints(token);
    if (res.status === 200) {
      const sprintsData = res.data;
      setSprints(sprintsData);

      // Always find the true ACTIVE sprint from API — never trust localStorage
      const active = sprintsData.find((sp) => sp.sprintStatus === "ACTIVE");

      if (active) {
        setSelectedSprint(active);
        localStorage.setItem("selectedSprint", JSON.stringify(active));
        window.dispatchEvent(new Event("sprintChanged"));
      } else {
        // No active sprint exists at all
        setSelectedSprint(null);
        localStorage.removeItem("selectedSprint");
      }
    }
  } catch (error) {
    console.error("Error fetching sprints:", error);
  }
};

    if (token) {
      fetchTeams();
      fetchSprints();
    }
  }, [token]);

  // Kept for backward compatibility in case anything else still dispatches
  // this event; routes it through setSearchParams instead of local state.
  useEffect(() => {
    const handleTabChange = (e) => {
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev);
        next.set("tab", e.detail);
        return next;
      });
    };
    window.addEventListener("employeeSprintTabChange", handleTabChange);
    return () => {
      window.removeEventListener("employeeSprintTabChange", handleTabChange);
    };
  }, [setSearchParams]);

  const handleTabChange = (e, newValue) => {
    const tab = newValue === 0 ? "active" : "completed";
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      next.set("tab", tab);
      return next;
    });
    if (tab === "completed") {
      setSelectedSprint(null);
    } else {
      const saved = localStorage.getItem("selectedSprint");
      if (saved) {
        setSelectedSprint(JSON.parse(saved));
        window.dispatchEvent(new Event("sprintChanged"));
      }
    }
  };

  return (
    <>
      <NavbarPage />
      <EmployeeNavbarVertical
        isOpen={isSidebarOpen}
        onToggle={() => setIsSidebarOpen(!isSidebarOpen)}
      />

     <main
  style={{
    marginLeft: isSidebarOpen ? 240 : 64,  // 64px when collapsed (icon-only), 240px when open
    marginTop: 60,
    padding: "16px 24px",               
    background: "#fff",
    minHeight: "calc(100vh - 60px)",
    transition: "margin-left 0.25s ease",  
  }}
>
       {!isReportingPage && !isTicketingPage && activeTab === "dashboard" && (
  <EmployeeDashboard />
)}

{!isReportingPage && !isTicketingPage && activeTab !== "dashboard" && (
  <>
            {/* ── Tab bar + dropdowns ── */}
                        <div
              style={{
                background: "#fff",
                padding: "0px 16px",
                marginBottom: "16px",
                position: "sticky",
                top: 0,
                zIndex: 900,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {/* MUI Tabs */}
              <Box sx={{ borderBottom: 0, flex: 1 }}>
                <Tabs
                  value={activeTab === "active" ? 0 : 1}
                  onChange={handleTabChange}
                  aria-label="sprint tabs"
                >
                  <Tab label="Active Sprint" />
                  <Tab label="Completed Sprint" />
                </Tabs>
              </Box>

              {/* Right side */}
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                {/* Active Sprint tab → show sprint name as plain text */}
                {activeTab === "active" && selectedSprint && (
                  <span style={{
                    border: "1px solid #dee2e6",
                    borderRadius: "6px",
                    padding: "5px 14px",
                    fontSize: "14px",
                    fontWeight: "500",
                    color: "#374151",
                    background: "#fff",
                  }}>
                    {selectedSprint.sprintName}
                  </span>
                )}
              </div>
            </div>

            {/* Tab content */}
            {activeTab === "planning" && <PlanningBacklogTab />}
            {activeTab === "active" && <EmployeeActiveSprint />}
            {activeTab === "completed" && <EmployeeCompletedSprint />}
          </>
        )}

        {(isReportingPage || isTicketingPage) && <Outlet />}
      </main>
    </>
  );
};

export default EmployeeLayout;